import apiClient from '../../shared/auth/services'

export const gazoKensakuService = {
  // Get satsuei memo category list (for dropdown)
  async getSatsueiMemoCategory() {
    try {
      const response = await apiClient.post('/getSatsueiMemoCategory', {
        isContainSatsueiMemoColumn: false
      })
      return response.data
    } catch (error) {
      console.error('Get satsuei memo category error:', error)
      throw error
    }
  },

  // Get image tag category list
  async getImageTagCategoryList(satsueiMemoCategoryId) {
    try {
      const response = await apiClient.post('/getImageTagCategoryList', {
        satsueiMemoCategoryId,
        isContainDeleted: true
      })
      return response.data
    } catch (error) {
      console.error('Get image tag category list error:', error)
      throw error
    }
  },

  // Get image tag list
  async getImageTagList(satsueiMemoCategoryId, imageTagCategoryId) {
    try {
      const response = await apiClient.post('/getImageTagList', {
        satsueiMemoCategoryId,
        imageTagCategoryId,
        isContainDeleted: true
      })
      return response.data
    } catch (error) {
      console.error('Get image tag list error:', error)
      throw error
    }
  },

  // Get object image list (search results)
  async getObjectImageList(searchParams) {
    try {
      const data = {}
      
      // Handle null or undefined searchParams
      if (!searchParams) {
        searchParams = {}
      }
      
      // Object ID specification
      if (searchParams.objectIds && searchParams.objectIds.length > 0) {
        data.objectIds = searchParams.objectIds
      }

      // Image tag specification
      if (searchParams.imageTags && searchParams.imageTags.length > 0) {
        data.imageTags = searchParams.imageTags
      }
      
      if (searchParams.imageTagSearchType !== undefined) {
        data.imageTagSearchType = searchParams.imageTagSearchType
      }

      const response = await apiClient.post('/getObjectImageList', data)
      return response.data
    } catch (error) {
      console.error('Get object image list error:', error)
      throw error
    }
  },

  // Get object image tag
  async getObjectImageTag(objectId, objectImageId) {
    try {
      const response = await apiClient.post('/getObjectImageTag', { objectId, objectImageId })
      return response.data
    } catch (error) {
      console.error('Get object image tag error:', error)
      throw error
    }
  },

  // Get image - returns blob data for proper cleanup
  // imageType: optional 'satsueiImage' for full image (e.g. carousel); default 'thumb_comp'
  async getImage(objectId, objectImageId, objectImageEditId, filenameExtension, isUploaded, imageType) {
    try {
      const type = imageType === 'satsueiImage' ? 'satsueiImage' : 'thumb_comp'
      const params = {
        objectId,
        objectImageId,
        objectImageEditId: objectImageEditId !== null && objectImageEditId !== undefined ? objectImageEditId : '',
        filenameExtension,
        isUploaded: isUploaded !== null && isUploaded !== undefined ? isUploaded : false,
        type,
      }
      if (type !== 'satsueiImage') {
        params.width = '148'
        params.height = '148'
      }
      const response = await apiClient.get('/getImage', {
        params,
        responseType: 'blob',
        headers: { Accept: 'image/jpeg' }
      })
      return response.data // Return blob data instead of URL
    } catch (error) {
      console.error('Failed to get image blob:', error)
      throw error
    }
  },

  // Legacy method that returns URL (deprecated - use getImage with useBlobUrl hook instead)
  async getImageUrl(objectId, objectImageId, objectImageEditId, filenameExtension, isUploaded) {
    try {
      const params = {
        objectId,
        objectImageId,
        objectImageEditId: objectImageEditId !== null && objectImageEditId !== undefined ? objectImageEditId : '',
        filenameExtension,
        isUploaded: isUploaded !== null && isUploaded !== undefined ? isUploaded : false,
        type: 'thumb_comp',
        width: '148',
        height: '148'
      }
      
      const response = await apiClient.get('/getImage', {
        params,
        responseType: 'blob',
        headers: { Accept: 'image/jpeg' }
      })
      
      return URL.createObjectURL(response.data)
    } catch (error) {
      console.error('Failed to get image URL:', error)
      throw error
    }
  }
}

export default gazoKensakuService
